import { em } from 'polished'
import styled from 'styled-components'

import { BoxBase } from 'styles/components/layout'

export const BoxBaseStyled = styled(BoxBase)`
  background: ${p => p.theme.colors.catskillWhite};

  ${p => p.theme.mq.upLg} {
    background: transparent;
  }
`

export const Container = styled.div`
  background: ${p => p.theme.colors.catskillWhite};
  padding-bottom: ${em(189)};
  display: flex;

  ${p => p.theme.mq.upMd} {
    padding-bottom: 0;
  }

  ${p => p.theme.mq.upLg} {
    border-bottom-left-radius: ${p => p.theme.blocks.blockBorderRadius};
    border-bottom-right-radius: ${p => p.theme.blocks.blockBorderRadius};
    margin-left: -${p => p.theme.indents.baseIndentMd};
    margin-right: -${p => p.theme.indents.baseIndentMd};
    padding-left: ${p => p.theme.indents.baseIndentMd};
    padding-right: ${p => p.theme.indents.baseIndentMd};
  }
`

export const IconWrapper = styled.div`
  bottom: ${em(-25)};
  height: ${em(189)};
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
  width: ${em(152)};

  ${p => p.theme.mq.upMd} {
    left: 0;
    margin-right: ${em(40)};
    position: relative;
    transform: none;
    flex-shrink: 0;
    align-self: flex-end;
  }
`

export const TextWrapper = styled.div`
  padding-top: ${em(40)};
  padding-bottom: ${em(40)};
`

export const Article = styled.div`
  display: inline-block;
  max-width: 90%;

  ${p => p.theme.mq.upMd} {
    max-width: none;
  }
`
